import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: '"Times New Roman", Times, serif',
  },
});

export default theme;
